import React, { useState, useCallback, useEffect } from "react";
// import { Icons, toast } from "react-toastify";
import useWebSocket, { ReadyState } from "react-use-websocket";

export const WebSocketDemo = () => {
    //Public API that will echo messages sent to it back to the client
    const [socketUrl, setSocketUrl] = useState(
        "ws://localhost:8000/ws/open_position_socket/36/91108"
    );
    const [messageHistory, setMessageHistory] = useState([]);

    const { sendMessage, lastMessage, readyState } = useWebSocket(socketUrl);

    useEffect(() => {
        if (lastMessage !== null) {
            setMessageHistory((prev) => prev.concat(lastMessage));
        }
        console.log("jjj", lastMessage)
        // toast.info(lastMessage ? lastMessage.data : null, {
        //     autoClose: 3000,
        //     className: "my-custom-toast",
        //     limit: 3,
        //     style: {
        //         fontSize: "15px",
        //     },
        //     icon: (
        //         <span role="img" aria-label="info">
        //             ℹ️
        //         </span>
        //     ),
        // });
    }, [lastMessage]);

    const connectionStatus = {
        [ReadyState.CONNECTING]: "Connecting",
        [ReadyState.OPEN]: "Open",
        [ReadyState.CLOSING]: "Closing",
        [ReadyState.CLOSED]: "Closed",
        [ReadyState.UNINSTANTIATED]: "Uninstantiated",
    }[readyState];
    return;
    // return (
    //     <div>

    //         {/* <button onClick={handleClickChangeSocketUrl}>
    //             Click Me to change Socket Url
    //         </button>
    //         <button
    //             onClick={handleClickSendMessage}
    //             disabled={readyState !== ReadyState.OPEN}
    //         >
    //             Click Me to send 'Hello'
    //         </button> */}
    //         <span>The WebSocket is currently {connectionStatus}</span>
    //         {lastMessage ? <span>Last message: {lastMessage.data}</span> : null}
    //         {/* <ul>
    //             {messageHistory.map((message, idx) => (
    //                 <span key={idx}>{message ? message.data : null}</span>
    //             ))}
    //         </ul> */}
    //     </div>
    // );
};
